var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
var ConfiguratorServiceImpl = /** @class */ (function () {
    function ConfiguratorServiceImpl() {
        this._canvas = document.getElementById('canvas');
        this._canvasContext = this._canvas.getContext('2d');
        this._canvas.width = window.innerWidth;
        this._canvas.height = window.innerHeight;
    }
    Object.defineProperty(ConfiguratorServiceImpl.prototype, "canvas", {
        get: function () {
            return this._canvas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfiguratorServiceImpl.prototype, "canvasContext", {
        get: function () {
            return this._canvasContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfiguratorServiceImpl.prototype, "width", {
        get: function () {
            return this._canvas.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfiguratorServiceImpl.prototype, "height", {
        get: function () {
            return this._canvas.height;
        },
        enumerable: false,
        configurable: true
    });
    ConfiguratorServiceImpl = __decorate([
        injectable()
    ], ConfiguratorServiceImpl);
    return ConfiguratorServiceImpl;
}());
export { ConfiguratorServiceImpl };
